import { render, staticRenderFns } from "./St21Cn2061ReportYearMonth.vue?vue&type=template&id=baba4240&scoped=true&"
import script from "./St21Cn2061ReportYearMonth.vue?vue&type=script&lang=js&"
export * from "./St21Cn2061ReportYearMonth.vue?vue&type=script&lang=js&"
import style0 from "./St21Cn2061ReportYearMonth.vue?vue&type=style&index=0&id=baba4240&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baba4240",
  null
  
)

export default component.exports